import {observer} from "mobx-react-lite";
import {SmartCaptcha} from "@yandex/smart-captcha";
import {ChangeEvent, useEffect} from "react";
import {Button} from "@shared/ui/Button";
import {TextField} from "@shared/ui/Textfield/TextField";
import {authStore} from "./authStore";
import {Form} from "../auth/Form";
import {passwordIcon, playerIcon} from "@shared/assets/icons";
import {ContentLayout} from "../ui";
import {Typography} from "@shared/ui/Typography/Typography";
import {Link} from "react-router-dom";


export const SignIn = observer(() => {

    const {
        signInData, setPassword,
        setNickname,
        clearErrorSignIn, getStatusCheckedCaptcha,
        checkIp, isLoading, login, hasAllowSignIn
    } = authStore

    const {password, nickname, isErrorSignIn, isCaptcha} = signInData

    const onChangeNicknameHandler = (e: ChangeEvent<HTMLInputElement>) => {
        setNickname(e.currentTarget.value)
    }

    const onChangePasswordHandler = (e: ChangeEvent<HTMLInputElement>) => {
        setPassword(e.currentTarget.value)
    }

    // const [isEmailFocus, setIsEmailFocus] = useState(false)

    // const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)

    useEffect(() => {
        checkIp()
    }, []);

    if (isLoading) {
        return null
    }

    return (
        <ContentLayout>
                <Form onSubmit={login} onFocus={clearErrorSignIn}>
                    <ContentLayout.Header title={`Авторизация`}>
                        <Button type={'submit'} fullWidth disabled={!hasAllowSignIn} color={'success'}>
                            Войти
                        </Button>
                    </ContentLayout.Header>
                    <Form.Error
                        text={'Вы ввели неверное имя пользователя или пароль.'}
                        isVisible={isErrorSignIn}
                    />
                    <ContentLayout.Content>
                        <Form.Field>
                            <TextField
                                label={'Имя пользователя'}
                                icon={playerIcon}
                                value={nickname}
                                onChange={onChangeNicknameHandler}
                                // style={{height: '2em'}}
                            />
                        </Form.Field>
                        <Form.Field>
                            <TextField
                                label={'Пароль'}
                                icon={passwordIcon}
                                type={'password'}
                                value={password}
                                onChange={onChangePasswordHandler}
                                // style={{height: '2em'}}
                            />
                        </Form.Field>
                    </ContentLayout.Content>
                        <Form.Footer>
                            {isCaptcha &&
                            <SmartCaptcha
                                // test
                                language={'ru'}
                                webview
                                // shieldPosition={'top-left'}
                                onSuccess={getStatusCheckedCaptcha}
                                sitekey={import.meta.env.VITE_SECRET_KEY_CAPTCHA}/>
                            }
                            {!isCaptcha &&
                                <Typography>
                                    <Typography type={"span"} align={'center'}>
                                        {`Нет аккаунта? `}
                                    </Typography>
                                    <Link to={`/registration`}>
                                        <Typography type={"span"} fontWeight={"bold"} align={'center'}>
                                            Зарегистрируйтесь
                                        </Typography>
                                    </Link>
                                </Typography>
                            }
                        </Form.Footer>
                </Form>
        </ContentLayout>
    )
})